<template>
  <router-view></router-view>
</template>

<script lang="ts">
export default {
    name: "App"
};
</script>
<style lang="scss" src="./css/component.scss"></style>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap");
body {
    margin: 0;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
}

body.hidden-overflow {
    overflow: hidden;
}
#app {
    background-color: var(--color-gray02);
    font-family: var(--font-primary);
    font-size: 16px;
    color: var(--color-dark);
    margin: 0;
    height: 100vh;
}

body.loading > div::after {
    content: "";
    position: fixed;
    top: 0px;
    background-color: #224b6277;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 1000;
}
</style>
